import styled from 'styled-components';
import slide4 from 'assets/images/mobile/slide4.jpg';
export { SubtitleMobile } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({ src: slide4 })`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  padding: 32px 48px;
`;
